/**
 * Web Style Import
 *
 */

import './style/dnb-global-error.scss'
